enum ColorScheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export default ColorScheme;
